/**************************************************
 * Nombre:       Tarjeta_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";

const Tarjeta_Producto = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{color: '#fff'}}
        >

            <Grid container size={{xs: 12, sm: 4, md: 4}} sx={{justifyContent: 'flex-start'}}>
                <img src={item.img} width={'100%'} height={'auto'} alt={item.nombre}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 8, md: 8}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                        <Typography sx={{fontSize: 20, fontWeight: 800}}>{item.nombre}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                        <Typography>{item.descripcion}</Typography>
                    </Grid>

                </Grid>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Producto